
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#717b8c","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/arrow-circle-right"}},[_c('path',{attrs:{"d":"M16.5 9A7.5 7.5 0 119 1.5 7.5 7.5 0 0116.5 9z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M8.055 11.648L10.695 9l-2.64-2.647","opacity":".4"}})])])
          )
        }
      }
    